import './confirmDialog.scss';

import React from 'react';

import { DialogLayout, DialogLayoutProps } from '../DialogLayout/DialogLayout';

interface ConfirmDialogProps extends DialogLayoutProps {
    message?: string;
}

const ConfirmDialog: React.FunctionComponent<ConfirmDialogProps> = ({
    message,
    ...rest
}: ConfirmDialogProps) => {
    return (
        <DialogLayout
            {...rest}
            renderContent={() => message && <div className="confirm-dialog-content">{message}</div>}
        />
    );
};

export { ConfirmDialog };
